module.exports = __webpack_public_path__ + "images/icons/icon-ribbon-success-c21cfa24.svg";